import { useParams, Link } from "react-router-dom";
import { Button } from "carbon-components-react";
import { RequestQuote16, Undo16 } from "@carbon/icons-react";

import styled from "styled-components";
import useSWR from "swr";

import { PuerperaRow, SchemaViewer } from "../../components/Viewer";

import { usePuerpera, useSchemas } from "../../hooks";
import { URL, Fetcher as F } from "../../api";

const Actions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 42px;
  > .bx--btn {
    margin-right: 32px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

const PuerperaSpace = styled.div`
  min-height: 3rem; // same as the Carbon button
`;

export const BabyInfoTab = ({ pid }) => {
  const puerpera = usePuerpera(pid);

  const { bid } = useParams();
  const { baby: babySchema } = useSchemas();

  const url = `${URL.baby}${bid}/?expand=`;
  const { data: babyData } = useSWR([url], F.withToken);

  const isLoading = !babyData;

  return (
    <div>
      <PuerperaSpace>
        <PuerperaRow showContract={true} data={puerpera ?? {}} />
      </PuerperaSpace>
      <SchemaViewer
        fields={babySchema.fields}
        excludes={[
          "id",
          "created",
          "modified",
          "bookroom_id",
          "employee_id",
          "puerperaNote_id",
          "puerpera_id",
        ]}
        isLoading={isLoading}
        data={babyData}
      />

      <Actions>
        <Button
          as={Link}
          to={`/puerpera/${pid}/babyEdit/${bid}`}
          kind="primary"
          size="small"
          renderIcon={RequestQuote16}
        >
          編輯
        </Button>
        <Button
          as={Link}
          to={`/puerpera/${pid}/baby`}
          kind="primary"
          size="small"
          renderIcon={Undo16}
        >
          返回新生兒列表
        </Button>
      </Actions>
    </div>
  );
};
